<div class="row">
  <div style="margin: 1rem">
    <span class="selectdatelabel">{{ 'selectDateRange' | translate }}</span>
    <input
      class="datepicker"
      type="text"
      ngDefaultControl
      ngxDaterangepickerMd
      [(ngModel)]="notificationDateRange"
      [showCustomRangeLabel]="true"
      [alwaysShowCalendars]="true"
      [ranges]="ranges"
      [linkedCalendars]="true"
      [showClearButton]="true"
      (ngModelChange)="changeDateRangeForNotification()"
    />
  </div>
</div>

<div class="row expansion-panel">
  <mat-expansion-panel class="md-expansion-demo-width" #myPanel expanded="true">
    <mat-expansion-panel-header>
      <mat-panel-title id="heading-alerts">{{
        'notifications.alerts.title' | translate
      }}</mat-panel-title>
    </mat-expansion-panel-header>

    <mat-table #table [dataSource]="dataSource">
      <ng-container matColumnDef="select">
        <mat-header-cell *matHeaderCellDef
          >{{ 'select' | translate }} &nbsp;&nbsp;&nbsp;<mat-checkbox
            [(ngModel)]="notificationForm.issuedAlertAll"
            (change)="checkAllIssuedAlert($event)"
            #showButtons
            ngDefaultControl
          ></mat-checkbox
        ></mat-header-cell>

        <mat-cell *matCellDef="let site"
          ><mat-checkbox
            [inputId]="site.rId"
            [checked]="site.select"
            [value]="site.rId"
            (change)="onClick($event)"
            #showButtons
            ngDefaultControl
          ></mat-checkbox
        ></mat-cell>
      </ng-container>

      <ng-container matColumnDef="refNo">
        <mat-header-cell *matHeaderCellDef>{{
          'notifications.alerts.refNo' | translate
        }}</mat-header-cell>
        <mat-cell *matCellDef="let site">{{ site.refNo }}</mat-cell>
      </ng-container>

      <ng-container matColumnDef="criticalityLevel">
        <mat-header-cell *matHeaderCellDef>{{
          'notifications.alerts.criticality' | translate
        }}</mat-header-cell>
        <mat-cell *matCellDef="let site">{{ site.criticalityLevel }}</mat-cell>
      </ng-container>

      <ng-container matColumnDef="loadName">
        <mat-header-cell *matHeaderCellDef>{{
          'notifications.alerts.loadName' | translate
        }}</mat-header-cell>
        <mat-cell *matCellDef="let site">{{ site.loadName }}</mat-cell>
      </ng-container>

      <ng-container matColumnDef="parameter">
        <mat-header-cell *matHeaderCellDef>{{
          'notifications.alerts.parameter' | translate
        }}</mat-header-cell>
        <mat-cell *matCellDef="let site">{{ site.parameter }}</mat-cell>
      </ng-container>

      <ng-container matColumnDef="ConditionwithValue">
        <mat-header-cell *matHeaderCellDef>{{
          'notifications.alerts.conditionWithValue' | translate
        }}</mat-header-cell>
        <mat-cell *matCellDef="let site"
          >{{ site.conditionOperator | operatorsPipe : operators }}&nbsp;{{
            site.conditionValue
          }}</mat-cell
        >
      </ng-container>

      <ng-container matColumnDef="firstStartTime">
        <mat-header-cell *matHeaderCellDef>{{
          'notifications.alerts.firstStartTime' | translate
        }}</mat-header-cell>
        <mat-cell *matCellDef="let site">{{ site.firstStartTime }}</mat-cell>
      </ng-container>

      <ng-container matColumnDef="occurrenceCounter">
        <mat-header-cell *matHeaderCellDef>{{
          'notifications.alerts.occurrenceCounter' | translate
        }}</mat-header-cell>
        <mat-cell *matCellDef="let site">{{ site.occurrenceCounter }}</mat-cell>
      </ng-container>

      <ng-container matColumnDef="lastStartTime">
        <mat-header-cell *matHeaderCellDef>{{
          'notifications.alerts.lastStartTime' | translate
        }}</mat-header-cell>
        <mat-cell *matCellDef="let site">{{ site.lastStartTime }}</mat-cell>
      </ng-container>

      <ng-container matColumnDef="lastEndTime">
        <mat-header-cell *matHeaderCellDef>{{
          'notifications.alerts.lastEndTime' | translate
        }}</mat-header-cell>
        <mat-cell *matCellDef="let site">{{ site.lastEndTime }}</mat-cell>
      </ng-container>

      <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
      <mat-row
        *matRowDef="let site; columns: displayedColumns"
        [ngClass]="{ highlight: site.isRead === false }"
      ></mat-row>
    </mat-table>

    <mat-paginator #paginator [pageSize]="10" [pageSizeOptions]="[5, 10, 20]">
    </mat-paginator>

    <mat-action-row>
      <div class="col-md-12 text-center">
        <button
          id="readAlerts"
          bciprimarybutton
          class="btn-primary btnclass"
          (click)="markAlerts(true)"
          ngDefaultControl
        >
          {{ 'notifications.alerts.btn.markAsRead' | translate }}
        </button>
        <button
          id="unreadAlerts"
          bciprimarybutton
          class="btn-primary btnclass"
          (click)="markAlerts(false)"
          ngDefaultControl
        >
          {{ 'notifications.alerts.btn.markAsUnread' | translate }}
        </button>
        <button
          id="exportAlerts"
          bciprimarybutton
          class="btn-primary btnclass"
          (click)="exportIssuedAlerts()"
          ngDefaultControl
        >
          {{ 'notifications.alerts.btn.exportTo' | translate }}
        </button>
        <button
          id="deleteAlerts"
          bciprimarybutton
          class="btn-primary btnclass"
          (click)="deleteAlerts()"
          ngDefaultControl
        >
          {{ 'notifications.alerts.btn.delete' | translate }}
        </button>
      </div>
    </mat-action-row>
  </mat-expansion-panel>
</div>
